<template>
  <div>
    <!--    <CommonTable-->
    <!--      ref="table"-->
    <!--      :data="tableData"-->
    <!--      :total="total"-->
    <!--      @change="handleTableChange"-->
    <!--      :operation="operation"-->
    <!--      @operation="handleOperation"-->
    <!--      :table-json="tablejson"-->
    <!--    >-->
    <!--    </CommonTable>-->
    <CommonTable
      ref="table"
      :data="tableData"
      :total="tableData.length"
      @change="handleTableChange"
      :operation="operation"
      @operation="handleOperation"
      :table-json="tablejson"
    >
    </CommonTable>
  </div>
</template>

<script>
import tablejson from './Model/Tablejson.Index'
import formTableMixin from '@/mixins/formTableMixin'
import { getRoleByOperationCode } from '@/authorized'
export default {
  mixins: [formTableMixin],
  components: {
    // ShadowHistory
  },
  props: {
    tableData: {
      type: Array,
      default: () => []
    },

    roleList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tablejson,
      operation: [
        {
          name: this.$t('Common.detail'),
          icon: 'icon-detail_16',
          type: 'detail',
          width: 100
          // hide: () => {
          //   return !this.detailRole
          // }
        }
      ],
      // queryApi: this.$api.device.device_shadow_list,
      queryApi: '',
      row: {}
    }
  },
  computed: {
    // detailRole() {
    //   let role = getRoleByOperationCode(this.roleList, 'detail')
    //   return role ? role.isPermission == 'Y' : false
    // }
  },
  // watch: {
  //   userId() {
  //     this.formSearch()
  //   }
  // },
  methods: {
    handleDetail(row) {
      if (row.productType === 'steamingOven') {
        const { href } = this.$router.resolve({
          name: 'DeviceDetail',
          query: {
            id: row.id
          }
        })
        window.open(href, '_blank')
      } else if (row.productType === 'refrigerator') {
        const { href } = this.$router.resolve({
          name: 'IceDeviceDetail',
          query: {
            id: row.id
          }
        })
        window.open(href, '_blank')
      }
    },
    handleOperation(data) {
      const { type, row } = data
      switch (type) {
        case 'detail':
          this.handleDetail(row)
          break
      }
    }
  }
}
</script>
